import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import type { FullBoatSearchDetail } from 'src/common/types/api/v4/boats/search';
import styles from './ListingDetails.module.scss';

export type ListingDetailsProps = {
  make?: FullBoatSearchDetail['make'];
  model?: FullBoatSearchDetail['model'];
  capacity: FullBoatSearchDetail['capacity'];
};

/** Except for the "Experiences" tag group, which is emphasized in above section  */
const ListingDetails: FC<ListingDetailsProps> = ({
  make, model, capacity,
}) => {
  const [t] = useTranslation('listing-page');

  return (
    <ul className={styles.root}>
      {make && (
        <Typography size="body-m" type="li">{make}</Typography>
      )}
      {model && (
        <Typography size="body-m" type="li">{model}</Typography>
      )}
      <Typography size="body-m" type="li">
        {`${t('capacity')}: `}
        <strong>{t('listing-details--capacity-max', { count: capacity })}</strong>
      </Typography>
    </ul>
  );
};

export default ListingDetails;
